import { render, staticRenderFns } from "./AccessProfileMaintain.vue?vue&type=template&id=1079f75b&"
import script from "./AccessProfileMaintain.vue?vue&type=script&lang=js&"
export * from "./AccessProfileMaintain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1079f75b')) {
      api.createRecord('1079f75b', component.options)
    } else {
      api.reload('1079f75b', component.options)
    }
    module.hot.accept("./AccessProfileMaintain.vue?vue&type=template&id=1079f75b&", function () {
      api.rerender('1079f75b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/security/access-profile/AccessProfileMaintain.vue"
export default component.exports